import React, { useEffect, useState } from "react";
import { Popover, Dropdown, Button, Tag, Timeline, Collapse } from "antd";
import AttachmentBox from "../AttachmentBox/AttachmentBox";
import { markUnmarkFavourite, editQuestionText } from "../../API/api";
import Button2 from "../Button2/Button2";
import {
  DeleteOutlineOutlined,
  EditOutlined,
  FavoriteBorderOutlined,
  LocalFireDepartment,
  PeopleAltOutlined,
  HelpOutline,
  CheckCircleOutline,
} from "@mui/icons-material";
import { ReactComponent as DownloadIcon } from "../../Icons/download.svg";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
// import Tags from "../answerBox/ExpertQA/Tags";
import Tags from "../../NewPages/OpenPage/Tags";
import { momentit } from "../../utils";
import { toast } from "react-toastify";
import { ReactComponent as FireIcon } from "./../../Icons/fire.svg";
import moment from "moment";

export default function QuestionBox({ data }) {
  const dispatch = useDispatch();
  const {
    openQuestionsData,
    advanceFilterModalToggle,
    getSelectedQuestion,
    deleteSelectedOpenQuestionUuid,
  } = bindActionCreators(Actions, dispatch);
  const [isFavorite, setFavorite] = useState(data.favourite);
  const openState = useSelector((state) => state.openQuestions);
  const [edit, setEdit] = useState(false);
  const [editQuestion, setEditQuestion] = useState(data.text);
  const [addditionalContext, setAdditionalContext] = useState(
    data.additionalContext && data.additionalContext !== ""
      ? data.additionalContext
      : "",
  );
  const [clarified, setClarified] = useState(false);
  const [checkQuestionValue, setCheckQuestionValue] = useState("");

  const isButtonDisabled = data.clarificationStatus
    ? (data.text === editQuestion &&
        data.additionalContext === addditionalContext) ||
      editQuestion === "" ||
      addditionalContext === ""
    : editQuestion === "";

  const containerStyle = {
    border: "1px solid #E0E2E6",
    borderRadius: "16px",
    background: "#FFFFFF",
    boxShadow: "0px 4px 16px 0px #1018280F",
    padding: "24px 36px 24px 36px",
    minHeight: "100px",
    marginBottom: "24px",
  };

  function formatDate(dateString) {
    const date = new Date(dateString);

    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  }
  const capitalize = (str = "") => {
    if (str === str.toUpperCase()) {
      return str;
    }

    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const onClickEdit = () => {
    setEdit(!edit);
  };

  const renderAttachemnt = (arr) => {
    return (
      <div>
        {arr.map((item, index) => (
          <div className="mb-1">
            {" "}
            <AttachmentBox key={index} attachment={item} />
          </div>
        ))}
      </div>
    );
  };

  const items = [
    {
      key: "1",
      label: (
        <a onClick={() => onClickEdit()}>
          <EditOutlined
            style={{
              marginBottom: "3px",
              marginRight: "5px",
              fontSize: "16px",
            }}
          />
          Edit
        </a>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "2",
      label: (
        <a onClick={() => onClickDeleteButton()}>
          <DeleteOutlineOutlined
            style={{
              marginBottom: "3px",
              marginRight: "5px",
              fontSize: "16px",
            }}
          />
          Delete
        </a>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "3",
      label: (
        <a onClick={() => onCLickFavorite(data, isFavorite ? false : true)}>
          <FavoriteBorderOutlined
            style={{
              marginBottom: "3px",
              marginRight: "5px",
              color: isFavorite && "#FF6A00",
              fontSize: "16px",
            }}
          />
          Favorite
        </a>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "4",
      label: (
        <a onClick={() => onClickWatchlistModal(data)}>
          <PeopleAltOutlined
            fontSize="24"
            style={{
              marginBottom: "3px",
              marginRight: "5px",
              fontSize: "18px",
            }}
          />
          Add to Watchlist
        </a>
      ),
    },
  ];

  const processItems = (items, clarificationStatus) => {
    if (clarificationStatus) {
      let editRemoved = false;
      let typeRemoved = false;

      return items.filter((item) => {
        if (!editRemoved && item.label?.props?.children?.[1] === "Edit") {
          editRemoved = true;
          return false;
        }
        if (!typeRemoved && item.type === "divider") {
          typeRemoved = true;
          return false;
        }
        return true;
      });
    }
    return items;
  };

  const DropdownComponent = ({ question }) => {
    return (
      <>
        <Dropdown
          menu={{ items: processItems(items, data.clarificationStatus) }}
        >
          <img
            src={require("../../Images/dots-vertical.png")}
            style={{ cursor: "pointer" }}
          />
        </Dropdown>
      </>
    );
  };

  const onCLickFavorite = (key, flag) => {
    if (key === undefined) return;
    markUnmarkFavourite(key.questionUuid).then((res) => {
      if (res === undefined) return;
      setFavorite(flag);
      let newOpenData = openState.openData.filter((obj) => {
        if (obj.questionUuid === key.questionUuid) {
          obj.favourite = flag;
        }
        return obj;
      });
      openQuestionsData(newOpenData);
    });
  };

  const infoContainer = {
    display: "flex",
    alignItems: "center",
  };
  const dateInfoStyles = {
    // width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    // marginBottom:'5px'
    // paddingLeft: "7px",
  };
  const textStyles = {
    fontSize: "21px",
    color: "#2A364A",
    lineHeight: "32px",
    fontWeight: "400",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    // width:'100%',
  };

  const buttonStyles = {
    padding: "8px 12px",
    borderRadius: "6px",
    fontSize: "14px",
    lineHeight: "24px",
    fontWeight: 400,
    boxShadow: "rgba(16, 24, 40, 0.05) 0px 1px 2px 0px",
    color: "rgb(255, 255, 255)",
    border: "1px solid rgb(255, 255, 255)",
    height: "40px",
    minWidth: "88px",
    background:
      "linear-gradient(90.39deg, rgb(0, 209, 255) 0.34%, rgb(0, 117, 255) 99.7%)",
    marginBottom: "14px",
    // opacity: (editQuestion === '' || data.text === editQuestion || data.additionalContext === addditionalContext) ? '0.34' : null,
    // opacity:data.clarificationStatus ? ((data.text === editQuestion && data.additionalContext === addditionalContext) || editQuestion === '') ? '0.34' : (editQuestion === '') ? '0.34' : null : false,
    // cursor:(editQuestion === '' || data.text === editQuestion || data.additionalContext === addditionalContext || data.additionalContext === '')  ? 'not-allowed' : 'pointer'
    opacity: isButtonDisabled ? "0.34" : null,
    cursor: isButtonDisabled ? "not-allowed" : "pointer",
  };

  const buttonStylesCancel = {
    padding: "8px 12px",
    borderRadius: "6px",
    fontSize: "14px",
    lineHeight: "24px",
    fontWeight: 400,
    boxShadow: "rgba(16, 24, 40, 0.05) 0px 1px 2px 0px",
    color: "black",
    border: "1px solid rgb(224, 226, 230)",
    height: "40px",
    minWidth: "88px",
    background: "#fff",
    marginBottom: "14px",
  };

  const renderToast = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };

  const onClickUpdateButton = () => {
    const payload = {
      questionUuid: data.questionUuid,
      questionText: editQuestion,
      domain: data.domain,
      postedDate: data.postedTimestamp,
      additionalContext: addditionalContext,
    };
    editQuestionText(payload).then((res) => {
      if (res === undefined) return;
      if (res.data.success) {
        let newData = [...openState.openData];
        newData.filter((obj, ind) => {
          if (obj.questionUuid === data.questionUuid) {
            obj.text = editQuestion;
            obj.additionalContext = addditionalContext;
            if (obj.clarificationStatus) {
              obj.clarificationStatus = false;
              setClarified(true);
              return obj;
            }
          }
        });
        openQuestionsData(newData);
        toast.success(renderToast(res.data.message), {
          position: toast.POSITION.TOP_RIGHT,
        });
        setEdit(false);
      }
    });
  };

  const onClickDeleteButton = () => {
    advanceFilterModalToggle({ bool: true, value: "deleteQuestion" });
    getSelectedQuestion(data);
    deleteSelectedOpenQuestionUuid(data.questionUuid);
  };

  const onClickWatchlistModal = (data) => {
    advanceFilterModalToggle({ bool: true, value: "addToWatchlistOpenTab" });
    getSelectedQuestion(data);
  };

  const additionalContextStyles = {
    border: "1px solid rgb(246, 247, 248)",
    marginBlock: "10px",
    borderRadius: "6px",
    background: "rgb(246, 247, 248)",
    padding: "12px",
    minHeight: "48px",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  };

  const clarificationBoxStyles = {
    background: "#f9ede5",
    padding: "5px 10px",
    borderRadius: "4px",
    marginBottom: "12px",
  };

  const onButtonCancel = () => {
    setEdit(false);
    setEditQuestion(data.text);
    setAdditionalContext(data.additionalContext);
  };

  const QuestionTextComponent = () => {
    return (
      <>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "baseline",
          }}
        >
          <div style={textStyles}>
            {/* {data.userInitiatedCuration && data.text.length < 43 && (
							<Tag color={'#6c94ba'} style={{fontWeight:'bold'}}>Requested Update</Tag>
						)} */}
            {data.express && (
              <>
                <FireIcon style={{ marginRight: "5px" }} />
              </>
            )}
            {data.text}
            {/* {data.userInitiatedCuration && data.text.length > 43 && (
							<Tag color={'#6c94ba'} style={{fontWeight:'bold',display:'inline-block',marginLeft:'5px'}}>Requested Update</Tag>
						)} */}
            {/* {data.clarificationStatus && data.text.length > 43 && (
							<>
								<Tag onClick={() => setEdit(true)} color={'#fd7400'} icon={<HelpOutline style={{ marginRight: '5px', fontSize: '18px' }} />} style={{ fontWeight: 'bold', cursor: 'pointer' }}>Expert requested for clarification</Tag>
							</>
						)} */}
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            {/* {
							clarified && (
								<Tag style={{fontWeight:'bold',backgroundColor:'green',color:'white'}} icon={<CheckCircleOutline style={{ marginRight: '5px', fontSize: '18px', fontWeight: 'bold' }} />}>Request Clarified</Tag>
							)
						} */}
            {/* {data.clarificationStatus && data.text.length < 43 && (
							<>
								<Tag onClick={() => setEdit(true)} color={'#fd7400'} icon={<HelpOutline style={{ marginRight: '5px', fontSize: '18px' }} />} style={{ fontWeight: 'bold', cursor: 'pointer' }}>Expert requested for clarification</Tag>
							</>
						)} */}
            {data.seekerAttachments && data.seekerAttachments.length > 0 && (
              <Popover title={renderAttachemnt(data.seekerAttachments)}>
                {" "}
                <Button2 onClickFunc={onCLickFavorite}>
                  <DownloadIcon />
                </Button2>
              </Popover>
            )}
            {
              <>
                <DropdownComponent question={data} />
              </>
            }
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div style={containerStyle}>
        {edit && data.clarifications && data.clarifications.length > 0 && (
          <>
            <div style={clarificationBoxStyles}>
              <span className="clarificationHeading">
                Clarification request from expert{" "}
                <span className="clarificationHeadingSubText">
                  (Clarify question to allow an expert to provide the best
                  answer)
                </span>
              </span>
              <ul>
                {data.clarifications.map((obj, ind) => {
                  return (
                    <>
                      <li key={ind}>{obj.context}</li>
                    </>
                  );
                })}
              </ul>
            </div>
          </>
        )}
        {edit === false && <QuestionTextComponent />}
        {edit && (
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {data.express && <FireIcon style={{ marginRight: "4px" }} />}
            <div style={{ width: "100%" }}>
              <div style={textStyles}>
                <textarea
                  wrap="soft"
                  style={{
                    border: "1px solid rgb(224, 226, 230)",
                    width: "100%",
                    padding: "12px",
                    borderRadius: "6px",
                    outline: "none",
                    resize: "none",
                  }}
                  rows={2}
                  type={"text"}
                  value={editQuestion}
                  onChange={(e) => setEditQuestion(e.target.value)}
                />
              </div>
            </div>
          </div>
        )}
        {edit === false &&
          data.additionalContext &&
          data.additionalContext !== "" && (
            <>
              <div style={additionalContextStyles}>
                {data.additionalContext}
              </div>
            </>
          )}
        {data.seekerAttachments &&
          data.seekerAttachments.length > 0 &&
          edit && (
            <div style={{ marginTop: "10px", width: "52px" }}>
              {
                <Popover title={renderAttachemnt(data.seekerAttachments)}>
                  {" "}
                  <Button2 onClickFunc={onCLickFavorite}>
                    <DownloadIcon />
                  </Button2>
                </Popover>
              }
            </div>
          )}
        <span
          style={{
            color: "#5C667B",
            fontWeight: 400,
            fontSize: "14px",
            marginTop: "5px",
            marginBottom: "5px",
          }}
        >
          Asked {momentit(data.postedTimestamp)}
        </span>
        {
          <>
            <Tags
              edit={edit}
              setEdit={setEdit}
              data={data}
              clarified={clarified}
            />
          </>
        }
        {
          <>
            {!data?.lifeOver ? (
              <>
                <div
                  style={{
                    padding: "12px 16px",
                    background: "#fafbfc",
                    borderLeft: "3px solid #d9d9d9",
                    marginBottom: "16px",
                    color: "#595959",
                  }}
                >
                  {`Open since ${formatDate(data.routingHistory.current.date)} at ${
                    data.routingHistory.current.level === "global" ||
                    data.routingHistory.current.level === "force rerouted"
                      ? "Global level"
                      : `${capitalize(data.routingHistory.current.level)} (${capitalize(
                          data.routingHistory.current.location,
                        )}) level`
                  } • Currently available with ${
                    data.routingHistory.current.expertCount
                  } experts.`}
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    padding: "12px 16px",
                    background: "#fafbfc",
                    borderLeft: "3px solid #d9d9d9",
                    marginBottom: "16px",
                    color: "#595959",
                  }}
                >
                  {`Expired on ${formatDate(data.routingHistory.expired.date)} at ${data.routingHistory.expired.level === "global" || data.routingHistory.expired.level === "force rerouted" ? "Global level" : `${capitalize(data.routingHistory.expired.level)} (${capitalize(data.routingHistory.expired.location)}) level`} • Last available with ${data.routingHistory.expired.expertCount} experts. `}
                </div>
              </>
            )}
          </>
        }
        {edit && (
          <>
            <span
              style={{
                color: "#5C667B",
                fontWeight: 400,
                fontSize: "14px",
                marginTop: "5px",
                marginBottom: "5px",
              }}
            >
              Additional Context (Optional)&nbsp;
            </span>
            <textarea
              wrap="hard"
              value={addditionalContext}
              onChange={(e) => setAdditionalContext(e.target.value)}
              rows={3}
              style={{
                width: "100%",
                border: "1px solid rgb(224, 226, 230)",
                outline: "none",
                padding: "12px",
                borderRadius: "6px",
                resize: "none",
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <Button
                onClick={() => onButtonCancel()}
                style={buttonStylesCancel}
              >
                Cancel
              </Button>
              {/* <Button disabled={(editQuestion === data.text && data.clarificationStatus)  || editQuestion === ''? true : false} style={buttonStyles} onClick={()=>onClickUpdateButton()}>Update</Button> */}
              {/* <Button 
							disabled={data.clarificationStatus ? (data.text === editQuestion || editQuestion === '') ? true : false : (editQuestion === '') ? true : false}
							style={buttonStyles} onClick={()=>onClickUpdateButton()}>Update</Button> */}
              <Button
                disabled={isButtonDisabled}
                style={buttonStyles}
                onClick={() => onClickUpdateButton()}
              >
                Update
              </Button>
            </div>
          </>
        )}
      </div>
    </>
  );
}
